/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_PartialInputs */

const en_directory_agent_readiness_status_partial = /** @type {(inputs: Directory_Agent_Readiness_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const zh_directory_agent_readiness_status_partial = /** @type {(inputs: Directory_Agent_Readiness_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分可用`)
};

/**
* | output |
* | --- |
* | "Partial" |
*
* @param {Directory_Agent_Readiness_Status_PartialInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_partial = /** @type {((inputs?: Directory_Agent_Readiness_Status_PartialInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_PartialInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_partial(inputs)
	return zh_directory_agent_readiness_status_partial(inputs)
});
export { directory_agent_readiness_status_partial as "directory.agent_readiness.status.partial" }